import React, { memo } from "react";
import { Spinner, Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import useUserAgent from "../../../hooks/useUserAgent.js";
import Frame from "../Frame/index.js";
import styles from "./SearchLoadingMessage.module.css";
import { t } from "@bookingcom/lingojs-core";
import { useSelector } from "react-redux";
import { getSearchSegments, getSearchType } from "../../../store/search/selectors.js";
import { getSearchFetchStatus, getSearchResultsVisibleIndexes } from "../../../store/searchResults/selectors.js";
const _SearchLoadingMessage = () => {
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    const searchType = useSelector(getSearchType);
    const searchSegments = useSelector(getSearchSegments);
    const searchFetchStatus = useSelector(getSearchFetchStatus);
    const searchResultsVisibleIndexes = useSelector(getSearchResultsVisibleIndexes);
    const shouldRender = isMobile && (!!searchResultsVisibleIndexes || searchFetchStatus !== "success");
    if (!shouldRender) {
        return null;
    }
    const destinationLocations = searchSegments?.[0]?.to?.map((item) => item?.cityName || item?.name);
    const destinationsList = destinationLocations?.join(i18n.trans(t("flights_sr_airline_separator")));
    let title;
    if (searchType === "ONEWAY") {
        title = i18n.trans(t("flights_sr_loading_one_way", { variables: { destination: destinationsList } }));
    }
    else if (searchType === "ROUNDTRIP") {
        title = i18n.trans(t("flights_sr_loading_rt", { variables: { destination: destinationsList } }));
    }
    else {
        title = i18n.trans(t("flights_sr_loading_multi"));
    }
    return (React.createElement("div", { "data-testid": "loading_message_sr", className: isMobile ? styles.rootMobile : styles.rootDesktop },
        React.createElement(Frame, { direction: "row" },
            React.createElement(Spinner, { size: "medium" }),
            React.createElement(Text, { variant: "body_2", className: styles.text }, title))));
};
export const SearchLoadingMessage = memo(_SearchLoadingMessage);
